import { render, staticRenderFns } from "./PaymentStep.vue?vue&type=template&id=a82d4c06"
import script from "./PaymentStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentStep.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports